var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferMngEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#EEF3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5142 12.8203H29.4886C18.8677 12.8203 10.2578 21.4302 10.2578 32.0511V67.9485C10.2578 78.5694 18.8677 87.1793 29.4886 87.1793H70.5142C81.1351 87.1793 89.745 78.5694 89.745 67.9485V32.0511C89.745 21.4302 81.1351 12.8203 70.5142 12.8203Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7404 54.4886C45.0508 54.4886 49.3558 50.1836 49.3558 44.8732C49.3558 39.5628 45.0508 35.2578 39.7404 35.2578C34.43 35.2578 30.125 39.5628 30.125 44.8732C30.125 50.1836 34.43 54.4886 39.7404 54.4886Z",
    fill: "#4F7CFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9219 66.6682C26.9219 58.9759 32.6911 53.8477 39.7424 53.8477C46.7937 53.8477 52.5629 58.9759 52.5629 66.6682V69.2323H26.9219V66.6682Z",
    fill: "#4F7CFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50 48.75H63.75",
    stroke: "#C9D7FF",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.25 45L65 48.75L61.25 52.5",
    stroke: "#C9D7FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0747 51.9229C76.969 51.9229 80.126 48.7659 80.126 44.8716C80.126 40.9773 76.969 37.8203 73.0747 37.8203C69.1804 37.8203 66.0234 40.9773 66.0234 44.8716C66.0234 48.7659 69.1804 51.9229 73.0747 51.9229Z",
    fill: "#E1E8FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1016 64.1037C64.1016 58.3344 67.9477 54.4883 73.0759 54.4883C78.2041 54.4883 82.0503 58.3344 82.0503 64.1037V65.3857H64.1016V64.1037Z",
    fill: "#E1E8FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9205 79.4894C82.5849 79.4894 87.1769 74.8974 87.1769 69.233C87.1769 63.5685 82.5849 58.9766 76.9205 58.9766C71.256 58.9766 66.6641 63.5685 66.6641 69.233C66.6641 74.8974 71.256 79.4894 76.9205 79.4894Z",
    fill: "#F4F6FB",
    stroke: "#D9DFEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9251 74.358C79.7573 74.358 82.0533 72.062 82.0533 69.2298C82.0533 66.3975 79.7573 64.1016 76.9251 64.1016C74.0929 64.1016 71.7969 66.3975 71.7969 69.2298C71.7969 72.062 74.0929 74.358 76.9251 74.358Z",
    stroke: "#6B7895"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.75 66.25L80 72.5",
    stroke: "#6B7895",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferMngEmptyState);
export default __webpack_public_path__ + "static/media/refer_mng_empty_state.f002dfaed6642d5f0e122989f19b9886.svg";
export { ForwardRef as ReactComponent };